import { useState } from 'react';
import { ConfirmDialog } from '../../Dialogs';
import { copyContractTemplate } from '../../../Service/restapi/contractTemplateService';
import { deleteContractTemplate } from '../../../Service/restapi/contractService';
import { ActionIcon, Menu } from '@mantine/core';
import { IconCopy, IconDots, IconTrashX } from '@tabler/icons';

export const ContractTemplateListActions = ({ templateName, reloadDocuments }) => {
  const [modalDelete, setModalDelete] = useState(false);

  const items = [
    { text: 'Löschen', onClick: () => setModalDelete(!modalDelete) },
    { text: 'Duplizieren', onClick: () => copy(templateName) },
  ];

  function deleteHandler() {
    deleteContractTemplate(templateName)
      .then((resp) => {
        if (resp.ok) {
        } else {
          console.error(`could not delete contract template ${templateName}`);
        }
        reloadDocuments();
      })
      .catch((error) => {
        console.error({ error });
        console.error(`could not delete contract template ${templateName}`);
      });
  }

  function copy(templateName) {
    copyContractTemplate(templateName)
      .then((resp) => {
        if (resp.ok) {
          reloadDocuments();
        } else {
          console.error(`could not copy template ${templateName}`);
        }
      })
      .catch((error) => {
        console.error({ error });
        console.error(`could not copy template ${templateName}`);
      });
  }


  return (
    <>
      <Menu radius="md" shadow="md" width={150} transition="slide-down" position="bottom-end">
        <Menu.Target>
          <ActionIcon>
            <IconDots />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item icon={<IconCopy size={16} />} onClick={() => copy(templateName)}>
            Duplizieren
          </Menu.Item>
          <Menu.Item color="red" icon={<IconTrashX size={16} />} onClick={() => setModalDelete(!modalDelete)}>
            Löschen
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
      <ConfirmDialog
        text="common.delete.document.confirm"
        subject="common.delete.document.confirm.head"
        open={modalDelete}
        toggle={() => setModalDelete(!modalDelete)}
        handler={deleteHandler}
      />
    </>
  );
};
